import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';

import { getKeyAction } from 'actions/navigation';

const GuardedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [hasKey, setHasKey] = useState(false);

  useEffect(() => {
    if (searchParams.get('key')) {
      setHasKey(true);
    } else if (searchParams.get('applicationId')) {
      dispatch(getKeyAction({
        entityType: 'application',
        entityId: searchParams.get('applicationId'),
        workflowType: params.workflowType || 'text2apply',
        success: (response) => {
          const newParams = new URLSearchParams(searchParams);
          newParams.delete('applicationId');
          newParams.set('key', response.key);
          setSearchParams(newParams);
          setTimeout(() => setHasKey(true), 100);
        },
      }));
    }
  }, [dispatch, searchParams, setSearchParams, params]);

  return hasKey ? children : null;
};

GuardedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GuardedRoute;
